import React, { useEffect, useState } from 'react'
import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, IconButton, InputLabel, ListItem, TextField, Typography } from '@mui/material'
import { ApiAddChecklistCategory, ApiDeleteChecklistCategory, ApiGetCategoryList, ApiGetChecklistCategoryList, ApiUpdateChecklistCategory } from '../../../../apiService/Core/Apicall.tsx'
import { Link, useNavigate } from 'react-router-dom'
import edit from '../../../../assets/images/editIcon.png'
import { CancelOutlined, Delete } from '@mui/icons-material'
import { toast } from 'react-toastify'



function ChecklistCategorylist() {

    const [CategoryList, setCategoryList] = useState<any[]>([])
    const [search, setsearch] = useState<string>('')
    const [filterItems, setfilterItems] = useState<any[]>([])
    const [categoryName, setCategoryName] = useState("")
    const [selectedCategory, setSelectedCategory] = useState<any>()
    const [open, setOpen] = useState(false)

    const navigate = useNavigate()


    const getCategoryList = async () => {
        const data = `?isActive=true` 
        const response = await ApiGetChecklistCategoryList(data)
        setCategoryList(response.data)
    }


    useEffect(() => {
        getCategoryList()
    }, [])

    useEffect(() => {
        if (CategoryList) {
            const filteredCategories = CategoryList.filter(category =>
                category.categoryName.toLowerCase().includes(search.toLowerCase())
            );
            setfilterItems(filteredCategories)
        }
    }, [search, CategoryList])


    const createChecklist = async () => {
        if (categoryName?.length < 0) { toast.error("Category name is required to create or update category"); return; }
        const data2 = {
            checklistCategoryId: selectedCategory?.checklistCategoryId,
            categoryName,
            isActive: true
        }
        try {
            const res = !selectedCategory ? await ApiAddChecklistCategory({categoryName}) :await ApiUpdateChecklistCategory(data2)

            if(res?.status){
                setSelectedCategory(null)
                setCategoryName("")
                setOpen(false)
                getCategoryList()
                
            }
        } catch (error:any) {
                toast.error(error?.message || "Something went wrong")
        }
    }

    const handleDelete = async (categoryId:number | string) =>{
        const isConfirm = window.confirm("Are you sure you want to delete this category?")
        if(!isConfirm) return;
        try {
            const data =`?checklistCategoryId=${categoryId}`
            const res = await ApiDeleteChecklistCategory(data)
            if(res?.status)
            {
                getCategoryList()
            }
        } catch (error:any) {
            toast.error(error?.message || "Something went wrong")
        }
    }

    return (
        <Box className='container-fluid p-3 extra' bgcolor='white' minHeight='calc(100vh - 180px)'>
            <Box className='d-flex mb-3 align-items-center flex-wrap justify-content-between' gap={2}>
                <Typography className='fw-bold col-12 col-md-auto' textAlign={{ xs: "center", md: "start" }} variant='h4'>Checklist Category List</Typography>
                {/* <Button variant="contained" onClick={() => { navigate('/admin/others/add-or-upate-category') }} className="table-row-background my-1 ml-auto" sx={{ width: 'fit-content', textTransform: 'none' }}>Add Category</Button> */}
                <Button  
                    onClick={()=>{setOpen(true)}}
                    className='link-btn text-white transform'
                >
                   + Add Category
                </Button>
            </Box>
            <FormControl className='my-3 mt-4 col-12'>
                <InputLabel>Search Category</InputLabel>
                <TextField
                    value={search}
                    onChange={(e) => { setsearch(e.target.value) }}
                />
            </FormControl>
            <Box className='d-flex align-items-center flex-wrap justify-content-between'>
                {filterItems && filterItems.map((item: any, index: number) => (
                    <Box width={{ xs: "100%", md: '49.5%' }} key={index} className='p-3 mt-2' sx={{ border: '1px solid #0000001A', borderRadius: '10px' }}>
                        <Box className=' d-flex justify-content-between align-items-center gap-1'>
                            <Box flex={1} className='px-0 d-flex align-items-center mb-1 justify-content-between'>
                                <Typography className='fw-bold  fs-18'>{item?.categoryName}</Typography>
                                <Typography className='fw-bold fs-18'>{item?.categoryWeightage}</Typography>
                            </Box>
                            <IconButton onClick={() => {setOpen(true); setCategoryName(item?.categoryName); setSelectedCategory(item) }}>
                                <Box sx={{ width: { xs: "100%", md: '75%' } }} component='img' src={edit} />
                            </IconButton>
                            <IconButton onClick={() => {handleDelete(item?.checklistCategoryId)}}>
                                <Delete className='text-danger'/>
                            </IconButton>
                        </Box>
                    </Box>
                ))}
            </Box>


            <Dialog open={open} className='p-2'>

                <DialogTitle className='m-0 mt-2 py-2 px-3 d-flex align-items-center justify-content-between' style={{ textAlign: "center" }}>
                    <Typography variant='h6'>{selectedCategory ? "Edit" : "Add"} Category</Typography>
                    <IconButton
                        onClick={() => { setOpen(false); setCategoryName(""); setSelectedCategory(null) }}
                    >
                        <CancelOutlined />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <div className="form-group mb-0">
                        <TextField
                            label="Category name"
                            fullWidth
                            size="small"
                            sx={{ marginTop: "10px", boxShadow: 'none' }}
                            value={categoryName || selectedCategory?.categoryName}
                            onChange={(e) => setCategoryName(e.target.value)}
                        />
                    </div>
                </DialogContent>
                <DialogActions sx={{ justifyContent: 'space-between', marginLeft: 2, marginRight: 2 }}>

                    <Button
                        variant="contained"
                        color="primary"
                        className='table-row-background'
                        sx={{ width: '100%' }}

                        onClick={() => {
                            createChecklist();
                        }}
                    >
                        {selectedCategory ? "Update" : "Add"}
                    </Button>
                </DialogActions>
            </Dialog>

        </Box>

    )
}

export default ChecklistCategorylist
